
import { Route, Routes } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import Service from "./pages/data/SubCategory";
import LoggeIn from "./components/LoggeIn";
import jwt_decode from 'jwt-decode';
import Page404 from "./pages/Page404";
import Login from "./components/adminLogin/Login";
import Privacy from "./pages/Privacy";
import Unit from "./pages/data/Unit";
import ServiceCategory from "./pages/data/Service";
import WorkingDay from "./pages/data/WorkingDay";
import Banner from "./pages/data/banner";
import MainService from "./pages/data/Category";
import UploadImage from "./pages/data/UploadImage";
import QrScan from "./user/qr_scan";
import TermsAndConditon from "./pages/TermsAndConditon";
import NoPolicyRefund from "./pages/NoPolicyRefund";
import SupportPage from "./pages/support";
import DeleteAccount from "./pages/DeleteAccountPage";

function App() {

  const logCheck = localStorage.getItem("data");
  let decoded_data = ""
  if (logCheck != null) {
    decoded_data = jwt_decode(logCheck)
  }
  return (
    <>
      <Routes>
        <Route path='/' element={<Login />} />
        <Route path='/support' element={<SupportPage />} />
        <Route path='/delete_account' element={<DeleteAccount />} />
        <Route path='/privacy' element={<Privacy />} />
        <Route path='/terms_and_condition' element={<TermsAndConditon />} />
        <Route path='/no_refund_policy' element={<NoPolicyRefund />} />
        <Route path="qr_scan" element={<QrScan />} />
        {logCheck !== null ?
          <>
            <Route path="/*" element={<LoggeIn />}>
              {/* Add your nested routes inside the LoggeIn component here */}
              <Route index element={<Dashboard />} />
              <Route path="banner" element={<Banner />} />
              <Route path="unit" element={<Unit />} />
              <Route path='mainService' element={<MainService />} />
              <Route path="service" element={<Service />} />
              <Route path="serviceCategory" element={<ServiceCategory />} />
              <Route path="uploadImage" element={<UploadImage />} />
              <Route path="workingDay" element={<WorkingDay />} />
            </Route>
          </>
          :
          <Route path='/' element={<Login />} />

        }

        <Route path="*" element={<Page404 />} />
      </Routes>

    </>
  );
}

export default App;
